<template>
  <!-- If your Sticker sits inside a section, use that as the scroll reference -->
  <section
    id="sticker-scroll-section"
    ref="sectionEl"
    class="md:min-h-[300vh] motion-reduce:md:min-h-screen"
  >
    <svg
      ref="svgEl"
      aria-hidden="true"
      class="sticky h-fit w-full motion-safe:will-change-transform motion-reduce:animate-none motion-reduce:transition-none md:top-0"
      fill="none"
      height="128"
      viewBox="0 0 128 128"
      width="128"
    >
      <g id="holo-sticker">
        <path
          id="base-shape"
          clip-rule="evenodd"
          d="M36.3127 12.986C39.9599 1.57544 54.103 -2.2142 62.9668 5.84412C65.31 7.97434 68.8109 8.16508 71.3552 6.30113C80.9797 -0.749906 94.6649 4.55588 97.1463 16.3004C97.8022 19.4051 100.53 21.6293 103.683 21.6298C115.609 21.6316 123.609 34.0062 118.76 44.9509C117.478 47.8441 118.391 51.2523 120.948 53.1171C130.619 60.171 129.878 74.8877 119.551 80.8521C116.821 82.4288 115.571 85.7191 116.555 88.7358C120.279 100.148 111.08 111.585 99.2192 110.291C96.0838 109.949 93.1473 111.865 92.1831 114.881C88.536 126.292 74.3929 130.081 65.5291 122.023C63.1859 119.893 59.685 119.702 57.1407 121.566C47.5162 128.617 33.831 123.311 31.3496 111.567C30.6937 108.462 27.9655 106.238 24.813 106.237C12.8873 106.235 4.88733 93.8608 9.73621 82.9161C11.018 80.0229 10.1048 76.6146 7.54809 74.7499C-2.12351 67.696 -1.38258 52.9793 8.94443 47.0149C11.6744 45.4382 12.9249 42.1479 11.9406 39.1312C8.21728 27.7194 17.4161 16.2819 29.2767 17.576C32.4121 17.9181 35.3486 16.0025 36.3127 12.986Z"
          fill="url(#pattern0_1_9)"
          fill-rule="evenodd"
        ></path>
        <path
          id="stroke"
          d="M36.3127 12.9861C39.9598 1.57545 54.1034 -2.21429 62.9672 5.84402C65.3102 7.97391 68.8105 8.16466 71.3547 6.30106C80.9792 -0.749979 94.6653 4.55579 97.1467 16.3003C97.8027 19.4049 100.531 21.6294 103.683 21.6299C115.609 21.6321 123.608 34.0059 118.759 44.9504C117.477 47.8436 118.391 51.2526 120.948 53.1173C130.619 60.1712 129.878 74.8868 119.552 80.8514C116.822 82.428 115.571 85.7186 116.556 88.7353C120.279 100.147 111.079 111.585 99.2186 110.291C96.0836 109.949 93.1476 111.864 92.1834 114.88C88.5363 126.291 74.3927 130.081 65.5289 122.022C63.1858 119.892 59.6847 119.702 57.1405 121.566C47.516 128.617 33.8308 123.311 31.3494 111.566C30.6934 108.462 27.9652 106.237 24.8127 106.237C12.8874 106.235 4.88752 93.8609 9.73592 82.9164C11.0177 80.0232 10.1043 76.6141 7.54759 74.7494C-2.12351 67.6954 -1.38232 52.9795 8.94437 47.0152C11.6743 45.4385 12.9247 42.1479 11.9405 39.1312C8.2172 27.7195 17.416 16.2818 29.2765 17.5759C32.4118 17.918 35.3485 16.0024 36.3127 12.9861ZM62.6306 6.21425C54.0362 -1.59918 40.3256 2.07456 36.7893 13.1384C35.7532 16.3798 32.5955 18.4405 29.2226 18.0726C17.7288 16.8185 8.80325 27.9037 12.4155 38.9756C13.4723 42.2147 12.131 45.7515 9.19469 47.4475C-0.816185 53.2293 -1.53953 67.5028 7.84283 74.3458C10.5896 76.3492 11.5705 80.01 10.1934 83.1184C5.48956 93.7357 13.2527 105.735 24.8133 105.737C28.2043 105.738 31.1342 108.13 31.8385 111.463C34.2462 122.858 47.5186 127.995 56.8454 121.163C59.5825 119.157 63.3475 119.363 65.8655 121.652C74.4599 129.466 88.1705 125.792 91.7068 114.728C92.743 111.487 95.9006 109.426 99.2735 109.794C110.767 111.048 119.692 99.963 116.08 88.8911C115.023 85.6519 116.365 82.115 119.301 80.419C129.312 74.6372 130.036 60.3637 120.653 53.5207C117.906 51.5173 116.926 47.8566 118.303 44.7482C123.006 34.1308 115.243 22.1313 103.683 22.1295C100.292 22.129 97.361 19.7369 96.6566 16.4033C94.249 5.00866 80.9775 -0.128784 71.6507 6.70399C68.9136 8.70919 65.1486 8.50317 62.6306 6.21425Z"
          fill="currentColor"
          fill-opacity="0.4"
        ></path>
        <g id="check-icon">
          <path
            d="M71.9832 57.1239C72.3619 56.468 72.1371 55.6292 71.4812 55.2505C70.8252 54.8718 69.9865 55.0966 69.6078 55.7525L62.5355 68.002L57.0046 64.8087C56.3487 64.43 55.5099 64.6548 55.1312 65.3107C54.7525 65.9667 54.9772 66.8054 55.6332 67.1841L61.56 70.606C62.6532 71.2371 64.0512 70.8626 64.6823 69.7693L71.9832 57.1239Z"
            fill="currentColor"
          ></path>
          <path
            clip-rule="evenodd"
            d="M59.6527 46.6456C50.1418 49.1941 44.4976 58.9701 47.046 68.4811C49.5945 77.992 59.3705 83.6362 68.8815 81.0878C78.3924 78.5393 84.0366 68.7633 81.4882 59.2523C78.9397 49.7414 69.1637 44.0972 59.6527 46.6456ZM49.6954 67.7712C47.539 59.7235 52.3149 51.4514 60.3626 49.295C68.4103 47.1387 76.6824 51.9145 78.8388 59.9622C80.9952 68.01 76.2193 76.282 68.1716 78.4384C60.1238 80.5948 51.8518 75.8189 49.6954 67.7712Z"
            fill="currentColor"
            fill-rule="evenodd"
          ></path>
        </g>
        <path
          id="top-text-path"
          d="M29.5293,64a34.4707,34.4707 0 0,1 68.9414,0"
          fill="none"
          transform="rotate(-15 64.001 64)"
        ></path>
        <text class="body-1-bold" fill="currentColor">
          <textPath
            href="#top-text-path"
            letter-spacing=".025em"
            side="right"
            startOffset="50%"
            text-anchor="middle"
          >
            {{ i18n(translations.topText) }}
          </textPath>
        </text>
        <path
          id="bottom-text-path"
          d="M19.049999999999997,64a44.95,44.95 0 1,0 89.9,0a44.95,44.95 0 1,0 -89.9,0"
          fill="none"
          transform="rotate(-15 63.9992 64)"
        ></path>
        <text class="body-1-bold" fill="currentColor">
          <textPath
            href="#bottom-text-path"
            letter-spacing=".125em"
            startOffset="25%"
            text-anchor="middle"
          >
            {{ i18n(translations.bottomText) }}
          </textPath>
        </text>
      </g>
      <defs>
        <!-- Pattern that uses the holographic image -->
        <pattern
          id="pattern0_1_9"
          height="1"
          patternContentUnits="objectBoundingBox"
          width="1"
        >
          <!-- We will animate this transform to "scroll the background" -->
          <use id="holoUse" href="#image0_1_9" />
        </pattern>

        <image
          id="image0_1_9"
          height="1024"
          :href="toPublicPath('/img/product/verified-refurbished/holo.avif')"
          preserveAspectRatio="none"
          width="1536"
        />
      </defs>
    </svg>
  </section>
</template>

<script setup lang="ts">
import { toPublicPath } from '#imports'
import { onBeforeUnmount, onMounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './Sticker.translations'

const i18n = useI18n()

// Refs to DOM elements
const sectionEl = ref<HTMLElement | null>(null)
const svgEl = ref<SVGSVGElement | null>(null)

// Animation bookkeeping
let rafId: number | null = null

// Utility
const clamp = (n: number, min: number, max: number) =>
  Math.min(Math.max(n, min), max)
const easeOutCubic = (x: number) => 1 - (1 - x) ** 3

// Compute scroll progress of the section in viewport (0 → 1)
function sectionProgress(): number {
  const el = sectionEl.value
  if (!el) return 0
  const rect = el.getBoundingClientRect()
  // How early to start relative to viewport, e.g. start when the section is still 30vh below.
  const startEarlyPx = window.innerHeight * 0.3
  // Treat the section as if it begins "startEarlyPx" earlier.
  const adjustedTop = rect.top - startEarlyPx
  // Keep total distance based on section scrub length
  const total = rect.height - window.innerHeight
  if (total <= 0) return 0
  // Compute progress using the adjusted top
  const raw = -adjustedTop / total

  return clamp(raw, 0, 1)
}

function update() {
  rafId = null
  const svg = svgEl.value
  if (!svg) return

  // Target the <use> within the pattern
  const holoUse = svg.querySelector<SVGUseElement>('#holoUse')
  if (!holoUse) return

  // Progress 0..1 with easing for smoothness
  const t = easeOutCubic(sectionProgress())

  // ORIGINAL matrix from your file:
  // matrix(a 0 0 d 0 ty) in objectBoundingBox units
  const a = 0.00620182
  const d = 0.00593602
  const baseTy = -3.45978

  // Scroll the “background” by shifting tx/ty.
  // Keep it subtle; you can increase these numbers for a stronger parallax.
  const maxDy = 5
  const ty = baseTy + maxDy * t

  // Optionally add a tiny scale drift to enhance the shimmer
  const scale = 1 + 0.03 * t
  const a2 = a * scale
  const d2 = d * scale

  holoUse.setAttribute('transform', `matrix(${a2} 0 0 ${d2} 0 ${ty})`)
}

function onScroll() {
  if (rafId == null) {
    rafId = requestAnimationFrame(update)
  }
}
function onResize() {
  if (rafId != null) cancelAnimationFrame(rafId)
  rafId = requestAnimationFrame(update)
}

onMounted(() => {
  requestAnimationFrame(update)
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
  window.removeEventListener('resize', onResize)
  if (rafId != null) cancelAnimationFrame(rafId)
})
</script>
